import $ from "jquery";

function eotwJSXFactory(elementName, attributes, ...children) {
    let $element = $(document.createElement(elementName));
    if ("object" === typeof attributes && null !== attributes) {
        if ("undefined" !== typeof attributes["unsafehtml"]) {
            attributes["unsafeHtml"] = attributes["unsafehtml"];
            delete attributes["unsafehtml"];
        }

        if ("undefined" !== typeof attributes["unsafeHtml"]) {
            $element.html(attributes["unsafeHtml"]);
            delete attributes["unsafeHtml"];
        }

        if ("undefined" !== typeof attributes["className"]) {
            if ("string" !== typeof attributes["class"]) {
                attributes["class"] = attributes["className"];
            } else {
                attributes["class"] = attributes["class"] + " " + attributes["className"];
            }
            delete attributes["className"];
        }

        if ("undefined" !== typeof attributes["htmlFor"]) {
            attributes['for'] = attributes['htmlFor'];
            delete attributes['htmlFor'];
        }

        $element.attr(attributes);
    }

    for (let child of children) {
        handleChildren($element, child);
    }

    return $element;
}

function handleChildren($element, children) {
    if (children === null || 'undefined' === typeof children) {
        return;
    }

    if (Array.isArray(children)) {
        children.forEach(handleChildren.bind(this, $element));
        return;
    }

    /** @var {HTMLElement} element */
    let element = $element[0];

    if (children instanceof $) {
        for (let child of children) {
            element.appendChild(child);
        }
    } else {
        element.appendChild(document.createTextNode(children));
    }
}

export default eotwJSXFactory;
